<template>
  <div>
    <a-modal :visible="visible" :footer="null" @cancel="cancel">
      <p>{{ $t('xrModal.installRequired1') }}</p>
      <p>{{ $t('xrModal.installRequired2') }}</p>
      <div class="button">
        <!-- <div class="installed" @click="ok">
          <span>{{ $t('xrModal.installed') }}</span>
          <span>{{ $t('xrModal.startNow') }}</span>
        </div> -->
        <div class="noInstalled" @click="downloadFile">
          <!-- <span>{{ $t('xrModal.notInstalled') }}</span> -->
          <span>{{ $t('xrModal.downloadNow') }}</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import Selection from '@/components/selection/index'
import { getClientUrl } from '@/api/lesson'

export default {
  components: {
    Selection
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    ok() {
      this.$emit('Ok', this.obj)
    },
    cancel() {
      this.$emit('update:visible', false)
    },
    async downloadFile() {
      const res = await getClientUrl()
      if (res.code === 200) {
        window.open(res.data.url, '_blank')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-modal{
  top: 30%;
  width: 310px !important;
  .ant-modal-content{
    background: url('./../../assets/img/bj_ts.png');
    background-size: 100% 100%;
    background-position: center;
  }
  p{
    color: #000;
    font-weight: 550;
    font-size: 16px;
    text-align: center;
    margin-bottom: 22px;
    &:first-child{
      margin-bottom: 6px;
    }
  }
  .button{
    display: flex;
    justify-content: center;
    >div{
      display: flex;
      cursor: pointer;
      padding: 12px 9px;
      margin-right: 40px;
      border-radius: 8px;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      border: 1px solid #E8E8E8;
      span{
        color: #000;
        font-size: 14px;
        &:last-child{
          font-size: 12px;
          font-weight: 400;
          color: #687F9C;
          line-height: 25px;
        }
      }
      &:hover{
        border-color: #5DC362;
        span:first-child{
          color: #5DC362;
        }
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
}
</style>
